import React from "react";

import solar from "../assets/pvt.jpg";
import MixedStorage from "../assets/Mixed Storage.jpg";
import heatpump from "../assets/heatpump.jpg";
import shower from "../assets/DHW.jpg";
import ZirkulationPump from "../assets/Zirkulation_pumpe.jpg";
import LadeSpeicher from "../assets/Ladespeicher.jpg";
import Heizung from "../assets/Heizung.jpg";
import zusatzHeizung from "../assets/Backup.jpg";
import Drei_Weg_Ventil from "../assets/3_Weg_Ventil.jpg";
import ground from "../assets/ground.png";

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

/*─────────────────────────────────────────────────────────
  SVG Input
─────────────────────────────────────────────────────────*/
function SvgEditableInput({
  x,
  y,
  label,
  value,
  onChangeValue,
  Width = 92,
  height = 38,
  align = "left",
  tooltipTitle,
}) {
  const ax =
    align === "center" ? x - Width / 2 : align === "right" ? x - Width : x;

  const extraW = tooltipTitle ? 20 : 0;

  return (
    <g>
      <foreignObject x={ax} y={y} width={Width + extraW} height={height}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="svg-field">
          <div className="svg-field-labelRow">
            <div className="svg-field-label svg-field-label--locked">
              {label}
            </div>
            {tooltipTitle && <InfoTooltip title={tooltipTitle} />}
          </div>

          <div className="svg-field-row">
            <input
              className="svg-field-value"
              value={value ?? ""}
              onChange={(e) => onChangeValue?.(e.target.value)}
            />
            <span className="svg-field-unit">°C</span>
          </div>
        </div>
      </foreignObject>
    </g>
  );
}

const InfoTooltip = ({ title }) => (
  <Tooltip
    title={title}
    arrow
    disablePortal
    PopperProps={{
      modifiers: [
        { name: "preventOverflow", options: { boundary: "viewport" } },
      ],
    }}
  >
    <InfoIcon
      fontSize="small"
      sx={{
        ml: 0.5,
        verticalAlign: "middle",
        cursor: "help",
        color: "#111827",
      }}
    />
  </Tooltip>
);

/*─────────────────────────────────────────────────────────
  Symbols
─────────────────────────────────────────────────────────*/
function PumpSymbol({
  x,
  y,
  size = 26,
  href,
  angle = 0,
  flipX = false,
  flipY = false,
}) {
  const sx = flipX ? -1 : 1;
  const sy = flipY ? -1 : 1;

  return (
    <g
      transform={`translate(${x} ${y}) scale(${sx} ${sy}) rotate(${angle}) translate(${-x} ${-y})`}
    >
      <image
        href={href}
        x={x - size / 2}
        y={y - size / 2}
        width={size}
        height={size}
        preserveAspectRatio="xMidYMid meet"
      />
    </g>
  );
}

function ValveIconSymbol({ x, y, size = 28, href }) {
  return (
    <image
      href={href}
      x={x - size / 2}
      y={y - size / 2}
      width={size}
      height={size}
      preserveAspectRatio="xMidYMid meet"
    />
  );
}

function Icon({ href, x, y, w, h }) {
  return <image href={href} x={x} y={y} width={w} height={h} />;
}

/*─────────────────────────────────────────────────────────
  SCHEMA: ground feeding the heatpump
─────────────────────────────────────────────────────────*/
export function HeatingSystemDiagramImage2({ formik }) {
  const setNum = (field, raw) => {
    if (raw === "") return formik.setFieldValue(field, "");
    const n = Number(raw);
    if (!Number.isNaN(n)) formik.setFieldValue(field, n);
  };

  return (
    <div className="hsd-card">
      <style>{`
        .hsd-card{
          background:#fff;
          border-radius:16px;
          padding:16px;
          box-shadow: 0 14px 40px rgba(0,0,0,0.12);
        }
        .hsd-title{
          text-align:center;
          margin:8px 0 6px;
          font-size:26px;
          letter-spacing:0.2px;
          color:#111827;
        }
        .hsd-sub{
          text-align:center;
          margin:0 0 14px;
          font-size:13px;
          color:#6b7280;
        }

        .svg-field{
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          background: rgba(255,255,255,0.92);
          box-shadow: 0 2px 10px rgba(0,0,0,0.10);
          padding: 6px 8px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 3px;
          overflow: visible;
        }
        .svg-field-label{
          width: 100%;
          border: 0;
          outline: none;
          background: transparent;
          font-size: 10.5px;
          line-height: 12px;
          color: #0f0f0fff;
          padding: 0;
        }
        .svg-field-labelRow{
          display:flex;
          align-items:center;
          gap:8px;
        }
        .svg-field-row{
          display: flex;
          align-items: baseline;
          gap: 6px;
        }
        .svg-field-value{
          flex: 1;
          min-width: 0;
          border: 0;
          outline: none;
          background: transparent;
          font-size: 14px;
          line-height: 16px;
          font-weight: 600;
          color: #111827;
          padding: 0;
        }
        .svg-field-unit{
          font-size: 11px;
          color: #0f0f0fff;
          user-select: none;
        }
        .svg-field:focus-within{
          border-color: #60a5fa;
          box-shadow: 0 0 0 3px rgba(96,165,250,0.25), 0 2px 10px rgba(0,0,0,0.10);
        }
        .svg-field-label--locked {
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding: 2px 6px;
          border: 1px solid transparent;
          line-height: 1.2;
          user-select: none;
          pointer-events: none;
        }
      `}</style>

      <h2 className="hsd-title">Schematische Darstellung</h2>
      <div className="hsd-sub">
        Raumheizung und Trinkwarmwasser
      </div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 720"
        width="100%"
        height="700px"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        aria-label="Heating system schematic"
        style={{ display: "block" }}
      >
        <defs>
          <style>{`
            .hot  { stroke: #dc2626; stroke-width: 3; fill: none; }
            .cold { stroke: #2563eb; stroke-width: 3; fill: none; }
            .circ { stroke: #10b981; stroke-width: 3; fill: none; }
            .ground { stroke: #10b981; stroke-width: 3; fill: none; stroke-dasharray: 8 6; }
            .dothot { stroke: #de4545ff; stroke-width: 3; fill: none; stroke-dasharray: 8 6; }
            .auxR { stroke: #ec842fff; stroke-width: 2.5; fill: none; }
            .auxB { stroke: #3b82f6; stroke-width: 2.5; fill: none; stroke-dasharray: 8 6; }
          `}</style>
        </defs>

        {/* =======================
             SOURCES (Erdreich(Ground))
           ======================= */}

        {/* NEW: Ground loop (dashed green) from bottom -> into heatpump */}
        {/* ground icon at bottom left, loop rises and connects into the heatpump area */}
        <path className="circ" d="M 145 595 V 290 H 145 V 290 H 300" />
        <PumpSymbol
          href={ZirkulationPump}
          x={145}
          y={515}
          angle={270}
          size={26}
        />
        <ValveIconSymbol href={Drei_Weg_Ventil} x={200} y={293} size={28} />
        <path className="ground" d="M 200 305 V 355" />
        {/* optional second branch return line (to look like a loop) */}
        <path className="ground" d="M 173 595 V 355 H 245 V 380 H 300" />

        {/* zusatzheizung to red and blue */}
        <path className="auxB" d="M 435 200 V 355" />
        <path className="dothot" d="M 400 200 V 290" />

        {/* hot supply red through pump */}
        <path className="auxR" d="M 620  300 H 710 V 200 " />
        <PumpSymbol
          href={ZirkulationPump}
          x={710}
          y={240}
          angle={90}
          size={26}
        />

        {/* Main hot supply trunk from unit to tanks (red) */}
        <path className="hot" d="M 350 290 H 620" />

        {/* TWW hot out to shower (red) */}
        <path className="hot" d="M 640 300 V 200 H 915" />

        {/* Branch down to RH storage (red) */}
        <path className="hot" d="M 520 290 V 445 H 600 " />

        {/* DHW return near shower (blue) */}
        <path className="cold" d="M 820 325 V 225 H 870" />

        {/* Cold water feed (blue) */}
        <path className="cold" d="M 875 325 H 600" />
        <text x={937} y={325} textAnchor="end" fontSize="12" fill="#374151">
          Kaltwasser
        </text>

        {/* Heating circuit supply to Heizung (red) */}
        <path className="hot" d="M 625 445 H 825" />
        <ValveIconSymbol href={Drei_Weg_Ventil} x={755} y={447} size={28} />
        <PumpSymbol
          href={ZirkulationPump}
          x={700}
          y={445}
          angle={0}
          size={26}
        />
        <path className="cold" d="M 755 520 V 458" />

        {/* Heating circuit return (blue) */}
        <path className="cold" d="M 885 520 H 625" />

        {/* return from TWW back to unit (blue in your drawing) */}
        <path className="cold" d="M 600 356 H 250 " />
        <PumpSymbol
          href={ZirkulationPump}
          x={405}
          y={356}
          angle={180}
          size={26}
        />

        {/* main return back to unit */}
        <path className="cold" d="M 650 520 H 490 V 356 " />

        {/* =======================
            Icons
           ======================= */}
        <Icon href={heatpump} x={225} y={255} w={160} h={130} />
        <Icon href={zusatzHeizung} x={340} y={120} w={170} h={105} />

        <Icon href={MixedStorage} x={580} y={230} w={75} h={170} />
        <text x={620} y={395} textAnchor="middle" fontSize="12" fill="#111827">
          TWW-Speicher
        </text>

        <Icon href={LadeSpeicher} x={580} y={395} w={75} h={170} />
        <text x={620} y={565} textAnchor="middle" fontSize="12" fill="#111827">
          RH-Speicher
        </text>

        <Icon href={shower} x={835} y={150} w={95} h={130} />
        <Icon href={Heizung} x={780} y={395} w={175} h={140} />
        <Icon href={ground} x={55} y={600} w={200} h={80} />

        {/* =======================
            Editable Inputs
           ======================= */}
        <SvgEditableInput
          x={465}
          y={245}
          //label="T_Sp_TWW"
          value={formik.values.dhwStorageTemp}
          onChangeValue={(v) => setNum("dhwStorageTemp", v)}
          tooltipTitle="Speicher-Sollwerttemperatur des Trinkwarmwasserspeichers."
        />

        <SvgEditableInput
          x={460}
          y={530}
          //label="T_Sp_RH"
          value={formik.values.shStorageTemp}
          onChangeValue={(v) => setNum("shStorageTemp", v)}
          tooltipTitle="Speicher-Sollwerttemperatur des Raumheizungsspeichers."
        />

        <SvgEditableInput
          x={680}
          y={395}
          //label="T_Heiz_Ein"
          value={formik.values.flowTemp}
          onChangeValue={(v) => setNum("flowTemp", v)}
          tooltipTitle="Die Vorlauf- und Rücklauftemperaturen des Heizkreises."
        />

        <SvgEditableInput
          x={690}
          y={540}
          //label="T_Heiz_Aus"
          value={formik.values.returnTemp}
          onChangeValue={(v) => setNum("returnTemp", v)}
          tooltipTitle="Temperatur des Heizwassers nach Wärmeabgabe im Gebäude."
        />

        <SvgEditableInput
          x={920}
          y={340}
          align="right"
          //label="T_KW"
          value={formik.values.coldWaterTemp}
          onChangeValue={(v) => setNum("coldWaterTemp", v)}
          tooltipTitle="Temperatur des Kaltwassers (z.B. 10 °C)."
        />

        <SvgEditableInput
          x={835}
          y={260}
          //label="T_Zapf"
          value={formik.values.T_Zapf}
          onChangeValue={(v) => setNum("T_Zapf", v)}
        />

        <SvgEditableInput
          x={715}
          y={285}
          //label="T_Zirk"
          value={formik.values.T_Zirk}
          onChangeValue={(v) => setNum("T_Zirk", v)}
        />

        <SvgEditableInput
          x={740}
          y={155}
          //label="T_TWW_Ein"
          value={formik.values.T_TWW_Ein}
          onChangeValue={(v) => setNum("T_TWW_Ein", v)}
        />

        {/* =======================
            House outline (same)
           ======================= */}
        <path
          d="M 40 165 L 505 20 L 960 150"
          fill="none"
          stroke="#9a4b4b"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M 70 165 L 70 595 L 940 595 L 940 150"
          fill="none"
          stroke="#7c6a11"
          strokeWidth="4"
        />
      </svg>
    </div>
  );
}
